import { render, staticRenderFns } from "./ProjectBalance.vue?vue&type=template&id=33271e0e"
import script from "./ProjectBalance.vue?vue&type=script&lang=ts"
export * from "./ProjectBalance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports